import firebase from "firebase/app";
import "firebase/functions";
import type { Store } from "redux";

import type { AppState } from "src/store";
import { handleImpersonationRevokedError } from "src/utils/impersonationRevocation";

let installed = false;

/**
 * Wrap `firebase.functions().httpsCallable` so revoked impersonation grants
 * bounce accountants to My Clients instead of leaving them on failing pages.
 */
export function installHttpsCallableRevokeInterceptor(
  store: Store<AppState>
): void {
  if (installed) return;
  installed = true;

  const functions = firebase.functions();
  const original = functions.httpsCallable.bind(functions);

  functions.httpsCallable = ((name: string, options?: any) => {
    const callable = original(name, options);
    return (data?: any) =>
      Promise.resolve(callable(data)).catch((error) => {
        handleImpersonationRevokedError(error, store);
        throw error;
      });
  }) as typeof functions.httpsCallable;
}
